<template lang="pug">
.onboarding-step
  .onboarding-step-header
    h1 Create a Feature
    p Ok... we now have a new board. Lets create a feature we can track, comment, and turn into reality. It's time to start building!
    br
    p This would typically be a request filed by a user to enhance your product. The title should be descriptive enough to indicate the work that needs to be done. Attaching images help highlight important things that are not easily conveyed in text.
  .onboarding-step-content
    .row.center
      .col.max
        form(@submit.prevent="submit")
          .form-field(
            :class="{ error: $v.form.name.$error, 'error-required': !$v.form.name.required }"
          )
            label
              input(
                v-model="$v.form.name.$model",
                type="text",
                placeholder="Title",
                maxlength="150"
              )
          .form-field(
            :class="{ error: $v.form.description.$error, 'error-required': !$v.form.description.required }"
          )
            label
              textarea(
                v-model="$v.form.description.$model",
                placeholder="Description",
                maxlength="2500"
              )
          //-div.form-field(v-if="form.attachments")
            .attachment(v-for="attachment in form.attachments")
              img(:src="attachment.url")
          .form-field
            form-upload(
              @uploaded="uploaded",
              endpoint="attachment",
              size="full"
            )
              button.button.upload(type="button")
                .form-field-upload
                  .empty(v-if="!form.attachments")
                    span Add Image (Optional)
                    font-awesome-icon(
                      :icon="['fad', 'image']",
                      style="--fa-primary-color: #00AC97;--fa-secondary-color: #00AC97;"
                    )
                  .uploaded(v-else)
                    .attachment(v-for="attachment in form.attachments")
                      div
                        span {{ attachment.fileName }}
                      img(:src="attachment.url")

          .form-field.no-margin
            SubmitButton(label="Create", :formState="formState")

      .col.max.animation
        LottieAnimation(svg="onboarding_3", :width="200", :height="200")
</template>

<script>
  import LottieAnimation from '@/components/helpers/LottieAnimation'
  import FormUpload from '@/components/form/FormUpload'
  import { mapGetters } from 'vuex'
  import { required } from 'vuelidate/lib/validators'
  import { form } from '@/mixins/form'

  export default {
    name: 'OnboardingPostCreate',
    mixins: [form],
    components: {
      LottieAnimation,
      FormUpload
    },
    beforeMount () {
    },
    data () {
      return {
        formState: 'initial',
        error: null,
        form: {
          name: '',
          description: '',
          attachments: null
        }
      }
    },
    validations: {
      form: {
        name: {
          required
        },
        description: {
          required
        }
      }
    },
    computed: {
      ...mapGetters({
        board: 'boards/selected',
      }),
    },
    methods: {
      uploaded (attachments) {
        this.$set(this.form, 'attachments', [attachments])
      },
      submit () {
        if (this.__formInvalid()) return
        this.formState = 'pending'
        let data = Object.assign({},
          this.form,
          {
            board: this.board._id
          }
        )
        if (data.attachments) {
          data.attachments = data.attachments.map(attachment => attachment._id)
        }
        this.$store.dispatch('features/postFeature', data).then(() => {
          // go to next step
          this.$emit('next')
        }, error => {
          //this.error = error
          //console.log(error)
        })
      }
    }
  }
</script>

<style lang="stylus" scoped>
.onboarding-step
  border $border-default
  .onboarding-step-header
    background-color $background-color
    border-bottom $border-default
    padding $spacing-3
    h1
      font-size 22px
      margin-bottom 30px
    p
      color $text-light
  .onboarding-step-content
    padding $spacing-3
  .animation
    +for_breakpoint(mobile)
      display none
</style>
